<template>
  <v-card :loading="loading" flat>
    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.importance"
          :items="importanceItems"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="درجه اهمیت"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.status"
          :items="statusItems"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="وضعیت"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.service_id"
          :items="services"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          item-text="nameFa"
          item-value="id"
          label="انتخاب سرویس"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.department_id"
          :items="departments"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          item-text="title"
          item-value="id"
          label="انتخاب دپارتمان"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.length"
          :items="[10, 25, 50, 100, 200, 400]"
          :menu-props="{ offsetY: true }"
          dense
          hide-details
          label="تعداد نمایش"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="tableProps.search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="جستجو"
          outlined
          @keydown.enter="reloadTable()"
          @click:append="reloadTable()"
          @click:clear="clearFilter"
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <data-table :columns="columns" :data="data" :translate="translate">
          <div slot="filters" />
        </data-table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            <div class="text-h3 text-center">{{ item.title }}</div>
          </v-toolbar>

          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn color="pink" dark text @click="dialog.value = false"
              >بستن</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import interActionBtn from "@/view/pages/tickets/interActionBtn";
import userLinkBtn from "@/view/pages/admin/adminNotifications/userLinkBtn";

export default {
  data() {
    return {
      loading: false,
      data: {},
      services: [],
      dialog: false,
      departments: [],
      importanceItems: [
        { text: "معمولی", value: "deposit" },
        { text: "مهم", value: "withdraw" },
        { text: "خیلی مهم", value: "withdraw" },
      ],
      item: null,
      url: "ticket",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
        },
        {
          label: "وضعیت",
          name: "status",
          orderable: true,
          transform: (value) => {
            return this.ticketStatus(value.data.status);
          },
        },
        {
          label: "اهمیت",
          name: "importance",
          orderable: true,
          transform: (value) => {
            return this.importanceStatus(value.data.importance);
          },
        },

        {
          label: "کاربر",
          name: "user",
          orderable: true,
          transform: (value) => {
            return value.data.user.name + " " + value.data.user.lastName;
          },
        },

        {
          name: "updated_at",
          label: "آخرین به روزرسانی",
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.updated_at);
          },
        },
        {
          name: "show",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "ticket_",
            buttons: [
              {
                name: "show",
                label: "تغییر وضعیت",
                icon: "pencil-alt",
                class: "btn-outline-info",
              },
              {
                name: "edit",
                label: "پاسخ تیکت",
                icon: "comment",
                class: "btn-outline-success",
              },
            ],
          },
        },

        // {
        //   name: 'actions',
        //   label: 'بازخورد',
        //   component: interActionBtn,
        //   handler: this.actions,
        //   event: 'action',
        //   meta: {
        //
        //     permission_prefix: 'notification_',
        //     // buttons: [
        //     //   {
        //     //     name: 'show',
        //     //     label: 'نمایش',
        //     //     icon: 'eye',
        //     //     class:'btn-outline-info',
        //     //   }
        //     // ]
        //   }
        // }
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        importance: "",
        service_id: "",
        status: "",
        department_id: "",
      },
      statusItems: [
        { text: "باز", value: "open" },
        { text: "بسته شده", value: "closed" },
      ],
    };
  },

  created() {
    this.getNotifications(this.url);
    let serviceJson = this.getServiceTicket().data;
    this.services = serviceJson.filter((value) => {
      return this.can(value.adminGate);
    });
    this.getDepartments();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  methods: {
    reloadTable(tableProps) {
      this.getNotifications(this.url, tableProps);
    },
    clearFilter() {
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
    getNotifications(url = this.url, query = this.tableProps) {
      this.loading = true;

      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {})
        .finally(() => (this.loading = false));
    },
    getDepartments() {
      this.requestApiGet("department").then((response) => {
        this.departments = response.data.data;
      });
    },
    reload() {
      this.getNotifications(this.url, this.tableProps);
    },

    reloadTable1(tableProps) {
      this.getNotifications(this.url, tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.$router.push({ name: "adminTickets.edit", params: { id: data.id } });
    },
    edit(data) {
      this.$router.push({ name: "tickets.edit", params: { id: data.id } });
    },

    ticketStatus(data) {
      if (data === "open") {
        return `<span class="badge-pill badge badge-success">باز</span>`;
      } else if (data === "closed") {
        return `<span class="badge-pill badge badge-danger">بسته</span>`;
      }
    },

    importanceStatus(data) {
      if (data === 1) {
        return `<span class="badge-pill badge badge-danger">بسیار مهم</span>`;
      } else if (data === 2) {
        return `<span class="badge-pill badge badge-warning">مهم</span>`;
      } else if (data === 3) {
        return `<span class="badge-pill badge badge-light">معمولی</span>`;
      }
    },

    notifyStatus(data) {
      if (data.status === "pending") {
        return "در انتظار";
      } else if (data.status === "sent") {
        return "ارسال شده";
      } else if (data.status === "denied") {
        return "ارسال نشده";
      } else if (data.status === "payed") {
        return "پرداخت شده";
      } else if (data.status === "approved") {
        return "تایید شده";
      }
    },
  },
};
</script>
